export default "__VITE_ASSET__CNw6qTJk__"